import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const productLandingPageContext = React.createContext({});
export let productLandingPageMachine: any;

export const useSMProductLandingPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  productLandingPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(productLandingPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    productLandingPageMachine,
    productLandingPageState: state,
    productLandingPageSend: send,
  };
};
